<div class='uploaderContainer'>
  <input #upload id='upload' type='file' style='display:none' (change)='this.onFileInputChange($event);' /> <!-- hide browser upload input-->

  <button class='btn btn-primary' (click)='this.clickInput()'>Select File</button>&nbsp;&nbsp;
  @if (this.isSelected) {
    <button class='btn btn-primary' (click)='this.uploadFile()'>Upload File</button>
  }
  @if (this.isSelected) {
    <div class='fileInformationContainer'>
      Filename: <strong><span>{{ this.filename }}</span></strong>
    </div>
  }
</div>
